import BoxState, { EVENT_TYPES } from '../../scripts/lib/box-state.js'

class BoxCartCount extends HTMLElement {
  #boxState = null
  #boundHandleBoxItemsChange = null

  constructor() {
    super()
    this.#boxState = BoxState.getInstance()
    this.#boundHandleBoxItemsChange = () => this.#handleBoxItemsChange()
  }

  connectedCallback() {
    this.#updateCount()
    this.#boxState.subscribe(EVENT_TYPES.BOX_ITEMS_CHANGE, this.#boundHandleBoxItemsChange)
  }

  disconnectedCallback() {
    this.#boxState.unsubscribe(EVENT_TYPES.BOX_ITEMS_CHANGE, this.#boundHandleBoxItemsChange)
  }

  #handleBoxItemsChange() {
    this.#updateCount()
  }

  #updateCount() {
    const boxItems = this.#boxState.boxItems
    const totalQuantity = Object.values(boxItems).reduce((sum, item) => sum + item.quantity, 0)
    this.textContent = totalQuantity.toString()
  }
}

if (!customElements.get('box-cart-count')) {
  customElements.define('box-cart-count', BoxCartCount)
}

export default BoxCartCount
